// Try-On Service
// Uses Replicate API - Fully automated, no manual methods!

import replicateService from './replicateService';

class TryOnService {
  /**
   * Apply style to user's photo using AILabTools API (automatic!)
   * @param {string} userImageUrl - URL of user's photo (blob URL or regular URL)
   * @param {Object} style - Style object with apiStyleId
   * @returns {Promise<string>} Preview image as data URL or URL
   */
  async applyStyle(userImageUrl, style) {
    try {
      // Check if API is configured
      if (!replicateService.isConfigured()) {
        throw new Error('Replicate API key not configured. Please set REACT_APP_REPLICATE_API_KEY in your .env file.');
      }

      if (!style.apiStyleId && !style.styleId) {
        throw new Error('Style ID is required. Please select a valid style.');
      }

      // Convert blob URL to File if needed
      let photoFile = userImageUrl;
      if (userImageUrl.startsWith('blob:') || userImageUrl.startsWith('data:')) {
        const response = await fetch(userImageUrl);
        const blob = await response.blob();
        photoFile = new File([blob], 'user-photo.jpg', { type: blob.type });
      }

      // Get API style ID
      const apiStyleId = style.apiStyleId || style.styleId;

      // Call appropriate API method based on category
      if (style.category === 'haircut') {
        return await replicateService.applyHairstyle(photoFile, apiStyleId);
      } else if (style.category === 'makeup') {
        return await replicateService.applyMakeup(photoFile, apiStyleId);
      } else {
        throw new Error(`Unknown style category: ${style.category}`);
      }
    } catch (error) {
      console.error('Error applying style:', error);
      throw error;
    }
  }

  /**
   * Validate image before processing
   * @param {File} file - Image file
   * @returns {Promise<boolean>}
   */
  async validateImage(file) {
    // Check file type
    if (!file.type.startsWith('image/')) {
      throw new Error('Please select an image file');
    }

    // Check file size (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      throw new Error('Image size should be less than 5MB');
    }

    // Check image dimensions
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        if (img.width < 100 || img.height < 100) {
          reject(new Error('Image is too small. Please use a larger image.'));
        } else {
          resolve(true);
        }
      };
      img.onerror = () => reject(new Error('Invalid image file'));
      img.src = URL.createObjectURL(file);
    });
  }
}

// Export singleton instance
export default new TryOnService();
